import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import useAppSelector from "@/core/helpers/useAppSelector";
import { ValidateCode } from "@/shared/ui";
import { safetySelector } from "@/domains/account/slice";
import useEmailCode from "@/domains/playerMenu/hooks/useEmailCode";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";
import useGameSettings from "@/domains/settings/hooks/useGameSettings";

type Props = {
  onClose: () => void;
};

export default function PlayerMenuSettingsSafetyDisableTfaEmailCheckContainer({ onClose }: Props) {
  const { getGameSettings } = useGameSettings();
  const { email } = useAppSelector(safetySelector);
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsPending,
    checkError,
    checkIsCompleted,
  } = useEmailCode();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    (async () => {
      if (email) {
        await sendCodeHandler(email, false);
        await getTimer({ type: "email", payload: email });
      }
    })();
  }, [email]);

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code, false);
  }, [checkCodeHandler, code]);

  const onSendCodeHandler = useCallback(async () => {
    await sendCodeHandler(email, false);
    await getTimer({ type: "email", payload: email });
  }, [sendCodeHandler, email]);

  useEffect(() => {
    if (checkIsCompleted) {
      getGameSettings();
      onClose();
    }
  }, [checkIsCompleted, onClose]);

  return (
    <FocusLock className="grow flex flex-col w-full h-full">
      <ValidateCode
        address={email}
        type={TfaMethod.EMAIL}
        code={code}
        onCodeChange={setCode}
        onSubmit={onSubmit}
        onSendCode={onSendCodeHandler}
        pending={checkIsPending}
        error={checkError || sendError}
        sendCodePending={sendIsPending}
        timer={timer}
      />
    </FocusLock>
  );
}
